import {
  CLEAR_ERRORS,
  CLEAR_INFO_MESSAGE,
  CLEAR_WARNING_MESSAGE,
  SET_ERRORS,
  SET_INFO_MESSAGE,
  SET_WARNING_MESSAGE,
  CLEAR_SUCCESS_MESSAGE,
  SET_SUCCESS_MESSAGE,
  SET_ADDTOBASKET_MESSAGE,
  CLEAR_ADDTOBASKET_MESSAGE,
} from "./alertsTypes";
import { createAction } from "@reduxjs/toolkit";

export const setSuccessMessage = createAction<string>(SET_SUCCESS_MESSAGE);

export const setWarningMessage = createAction<string[]>(SET_WARNING_MESSAGE);

export const clearWarningMessage = createAction<void>(CLEAR_WARNING_MESSAGE);

export const setErrors = createAction<string[]>(SET_ERRORS);

export const clearErrors = createAction<void>(CLEAR_ERRORS);

export const setInfoMessage = createAction<string[]>(SET_INFO_MESSAGE);

export const clearInfoMessage = createAction<void>(CLEAR_INFO_MESSAGE);

export const clearSuccessMessage = createAction<void>(CLEAR_SUCCESS_MESSAGE);


export const setAddToBasketMessage = createAction<string>(SET_ADDTOBASKET_MESSAGE);

export const clearAddToBasketMessage = createAction<void>(CLEAR_ADDTOBASKET_MESSAGE);